console.warn(
  "The regenerator/runtime module is deprecated; " +
    "please import regenerator-runtime/runtime instead."
);

module.exports = require("regenerator-runtime/runtime");



/*****************
 ** WEBPACK FOOTER
 ** /code/~/regenerator/runtime.js
 ** module id = 1177
 ** module chunks = 0
 **/